export default __webpack_public_path__ + "static/media/tr_7.55cd4c85.mp3";